var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogout(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16.01",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M13.05,12.26v1.25A2.73,2.73,0,0,1,10.16,16H2.89A2.73,2.73,0,0,1,0,13.51v-11A2.72,2.72,0,0,1,2.89,0h7.27a2.72,2.72,0,0,1,2.89,2.5V3.76a.73.73,0,0,1-1.44,0V2.51a1.36,1.36,0,0,0-1.45-1.25H2.89A1.35,1.35,0,0,0,1.45,2.51v11a1.35,1.35,0,0,0,1.44,1.25h7.27a1.37,1.37,0,0,0,1.44-1.25V12.26a.73.73,0,0,1,.83-.62.74.74,0,0,1,.62.62Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.71,7.35l-.87-.87a.38.38,0,0,0-.55,0,.4.4,0,0,0,0,.52l.62.62H10.22A.39.39,0,0,0,9.81,8a.38.38,0,0,0,.37.41h4.73l-.62.62a.39.39,0,1,0,.52.59l0,0,.87-.88A1,1,0,0,0,15.71,7.35Z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.1f273a06d3caba977965f57ec1313eab.svg";
export { ForwardRef as ReactComponent };